export default __webpack_public_path__ + "static/sr-713a027cc692520123efb544cd53c856.svg";